/* Deur-variantstappen (solza-door-options.liquid), bovenop de vendor
   variant-picker.js die de echte selectie/prijs/URL afhandelt.

   Regels hier:
   1. Alleen combinaties die als variant bestaan zijn kiesbaar; de rest
      wordt uitgeschakeld weergegeven. Wordt de huidige keuze ongeldig
      door een wissel eerder in de rij, dan springt de stap naar de
      eerste nog geldige waarde.
   2. De stap Draairichting verdwijnt wanneer de gekozen maat+type
      alleen "Niet van toepassing" kent; de waarde wordt dan stil op
      "Niet van toepassing" gezet. De pil "Niet van toepassing" is
      nooit een zichtbare keuze.
   3. Stapnummers zijn CSS-counters; verbergen van een stap hernummert
      dus vanzelf. */
(function () {
  /* Het label van een pil zoals de klant het leest: zonder de kleine
     regel eronder, want die draagt de toeslag en die hoort in de
     samenvatting. Gedeeld door de ingeklapte stapregel en de
     samenvatting, zodat daar niet twee lezingen van hetzelfde label
     ontstaan. */
  function pilLabel(invoer) {
    if (!invoer) return '';
    var label = null;
    if (invoer.id) label = document.querySelector('label[for="' + invoer.id + '"]');
    if (!label && invoer.nextElementSibling && invoer.nextElementSibling.tagName === 'LABEL') {
      label = invoer.nextElementSibling;
    }
    if (!label) return invoer.value || '';
    var kopie = label.cloneNode(true);
    [].slice.call(kopie.querySelectorAll('small')).forEach(function (k) { k.remove(); });
    return kopie.textContent.replace(/\s+/g, ' ').trim();
  }

  /* "Satijn vlak glas" -> "Glas: Satijn vlak"
     "Glas in lood Torino" -> "Glas in lood Torino"

     Het achterliggende woord "glas" eraf, en staat het er al vooraan,
     dan geen tweede keer ervoor -- anders stottert de regel. Dezelfde
     regel staat in snippets/solza-glasnaam.liquid voor de winkelwagen;
     de soortnamen komen uit het metafield en zijn Nederlands, ook op de
     Franse site, dus de toets op "glas" mag Nederlands zijn. Alleen het
     voorvoegsel komt uit een locale-sleutel. */
  function glasNaam(soort, sjabloon) {
    var kaal = String(soort || '').replace(/\s+glas$/i, '').trim();
    if (!kaal) return '';
    /* Bewust geen reguliere expressie met woordgrens: die overleefde het
       wegschrijven niet en werd een stuurteken, waardoor "Glas in lood
       Venezia" als "Glas: Glas in lood Venezia" op de pagina kwam. Deze
       vergelijking is niet minder leesbaar en kan niet stilletjes breken. */
    if (kaal.slice(0, 4).toLowerCase() === 'glas') return kaal;
    return (sjabloon || 'Glas: %s%').replace('%s%', kaal);
  }

  function initAll() {
    document.querySelectorAll('[data-door-options]:not([data-door-init])').forEach(init);
  }

  function init(root) {
    root.setAttribute('data-door-init', '');
    var naValue = root.getAttribute('data-door-na-value') || 'Niet van toepassing';
    var dataEl = root.querySelector('[data-door-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var steps = [].slice.call(root.querySelectorAll('[data-door-step]'));
    if (!steps.length) return;

    function optionIndex(step) {
      var node = step.querySelector('.m-product-option--node');
      return node ? parseInt(node.getAttribute('data-option-position'), 10) - 1 : -1;
    }

    function selectedValues() {
      return steps.map(function (step) {
        var checked = step.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });
    }

    /* bestaat er een variant waarvan de opties tot en met index
       `depth` overeenkomen met `values`? */
    function combinationExists(values, depth) {
      return variants.some(function (v) {
        for (var i = 0; i <= depth; i++) {
          if (values[i] == null) continue;
          if (v.options[optionIndex(steps[i])] !== values[i]) return false;
        }
        return true;
      });
    }

    function refresh() {
      var values = selectedValues();

      steps.forEach(function (step, stepIdx) {
        var stepValues = values.slice();
        step.querySelectorAll('.m-product-option--node').forEach(function (node) {
          stepValues[stepIdx] = node.getAttribute('data-value');
          var exists = combinationExists(stepValues, stepIdx);
          node.classList.toggle('solza-door-pill--unavailable', !exists);
          var input = node.querySelector('input[type="radio"]');
          if (input) input.toggleAttribute('data-door-unavailable', !exists);
        });

        /* keuze ongeldig geworden -> eerste geldige waarde kiezen */
        var checked = step.querySelector('input[type="radio"]:checked');
        if (checked && checked.hasAttribute('data-door-unavailable')) {
          var firstValid = step.querySelector('.m-product-option--node:not(.solza-door-pill--unavailable) input[type="radio"]');
          if (firstValid) { firstValid.click(); return; }
        }
      });

      /* draairichting-stap tonen of verbergen. Twee regels:
         1. Bij Type = Stomp (data-door-universal-type) verdwijnt de
            stap ALTIJD: een stompe deur heeft geen scharnier-
            voorbereiding en is universeel. Onderliggend wordt stil
            de eerste bestaande stompe variant gekozen -- de data
            draagt daar per serie 'Niet van toepassing' of een
            richtingswaarde, dat maakt voor de klant niet uit.
         2. Anders: verbergen wanneer alleen "Niet van toepassing"
            bestaat (regel uit de werkelijke variantcombinaties). */
      var universalType = root.getAttribute('data-door-universal-type') || '';
      var chosenType = (function () {
        var typeStep = steps.filter(function (s) { return s.getAttribute('data-option-name') === 'Type'; })[0];
        var c = typeStep && typeStep.querySelector('input[type="radio"]:checked');
        return c ? c.value : null;
      })();

      steps.forEach(function (step, stepIdx) {
        if (step.getAttribute('data-option-name') !== 'Draairichting') return;
        var naNode = step.querySelector('.m-product-option--node[data-value="' + cssEscape(naValue) + '"]');
        if (naNode) naNode.classList.add('solza-door-pill--na');

        var allNodes = [].slice.call(step.querySelectorAll('.m-product-option--node'));
        var others = allNodes.filter(function (n) { return n !== naNode; });
        var anyOtherAvailable = others.some(function (n) { return !n.classList.contains('solza-door-pill--unavailable'); });

        var typeIsUniversal = universalType && chosenType === universalType;

        if (typeIsUniversal || !anyOtherAvailable) {
          step.classList.add('solza-door-step--hidden');
          /* stil de eerste BESTAANDE combinatie kiezen (NvT of een
             richtingswaarde, wat de data ook draagt) */
          var checked = step.querySelector('input[type="radio"]:checked');
          if (!checked || checked.hasAttribute('data-door-unavailable')) {
            var firstValid = allNodes.filter(function (n) { return !n.classList.contains('solza-door-pill--unavailable'); })[0];
            if (firstValid) firstValid.querySelector('input[type="radio"]').click();
          }
        } else {
          step.classList.remove('solza-door-step--hidden');
          /* staat de keuze nog op NvT terwijl er echte richtingen
             zijn, kies dan de eerste beschikbare richting */
          var checkedDir = step.querySelector('input[type="radio"]:checked');
          if (checkedDir && checkedDir.value === naValue) {
            var firstDir = others.filter(function (n) { return !n.classList.contains('solza-door-pill--unavailable'); })[0];
            if (firstDir) firstDir.querySelector('input[type="radio"]').click();
          }
        }
      });

      /* Een stap met maar één mogelijkheid is geen keuze. Bij deze deur
         is Stomp bij dertien van de veertien maten de enige uitvoering;
         de stap Type stond er dan met één pil die al aanstond.

         De telling gaat over wat er bij de HUIDIGE maat te kiezen valt,
         niet over wat het product in totaal kent -- anders bleef de stap
         staan omdat er érgens een maat met twee uitvoeringen bestaat.
         Gevolg is dat Type kan opduiken bij een maatwissel; dat is juist,
         want dan valt er ook echt iets te kiezen. */
      steps.forEach(function (step) {
        if (step.getAttribute('data-option-name') === 'Draairichting') return;
        var kiesbaar = [].slice.call(step.querySelectorAll('.m-product-option--node'))
          .filter(function (n) {
            return !n.classList.contains('solza-door-pill--unavailable') && !n.classList.contains('solza-door-pill--na');
          });
        step.classList.toggle('solza-door-step--eenkeuze', kiesbaar.length < 2);
      });
    }

    function cssEscape(v) {
      return (window.CSS && CSS.escape) ? CSS.escape(v) : v.replace(/"/g, '\\"');
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('input[type="radio"]')) {
        /* na de vendor-afhandeling opnieuw evalueren */
        requestAnimationFrame(refresh);
        setTimeout(refresh, 50);
      }
    });

    /* klikken op een uitgeschakelde pil blokkeren */
    root.addEventListener('click', function (e) {
      var node = e.target.closest('.solza-door-pill--unavailable');
      if (node) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    refresh();
    var hertekenPrijs = initExtras(root, variants);
    initGlas(root, hertekenPrijs);
    initInklap(root);
    initAccFilter(root);
  }

  /* -- stappen in- en uitklappen ------------------------------------
     Alle keuzes onder elkaar zijn op een telefoon bijna duizend pixels;
     de bestelknop lag daardoor twee en een half scherm laag. Een stap
     die niet aan de beurt is, wordt daarom één regel met de gemaakte
     keuze en een wijzig-link.

     Drie regels:

     1. Eén stap tegelijk open. Bij binnenkomst is dat de eerste.
     2. Een stap sluit pas wanneer de klant een ándere stap opent, niet
        wanneer hij binnen dezelfde stap nog aan het kiezen is. Wie drie
        maten naast elkaar legt, houdt de maten in beeld; wie daarna glas
        kiest, opent daarmee de glasstap en sluit Maat.

        Er is dus geen automatisch doorschuiven na een keuze. Dat leek
        behulpzaam maar sloeg de stap dicht onder de hand van iemand die
        nog aan het vergelijken was. De prijzen bewegen ondertussen
        gewoon mee: de samenvatting herrekent bij elke maatwissel, ook
        als de glasstap dicht staat.
     3. Bij het wisselen wordt de bovenkant van het keuzeblok op zijn
        plek gehouden. Een stap die dichtklapt scheelt tweehonderd tot
        vierhonderd pixels; zonder die correctie schuift de pagina onder
        de vinger van de klant weg.

     Inklappen gebeurt met een klasse, niet door elementen weg te halen:
     de pillen blijven in de HTML staan, ook voor wie de pagina uitleest
     zonder JS te draaien. */
  function initInklap(root) {
    var stappen = [].slice.call(root.querySelectorAll('.solza-door-step'));
    if (stappen.length < 2) return;

    function zichtbaar(stap) {
      return !stap.classList.contains('solza-door-step--hidden') &&
             !stap.classList.contains('solza-door-step--eenkeuze');
    }

    /* De gekozen waarde zoals de klant hem ziet: het label van de
       aangevinkte pil, zonder de kleine regel eronder (die draagt de
       toeslag, en die staat in de samenvatting). */
    function gekozenTekst(stap) {
      var aangevinkt = [].slice.call(stap.querySelectorAll('input:checked'));
      if (!aangevinkt.length) return '';
      return aangevinkt.map(pilLabel).filter(Boolean).join(', ');
    }

    function isDicht(stap) { return stap.classList.contains('solza-door-step--dicht'); }

    function zetStand(stap, dicht) {
      stap.classList.toggle('solza-door-step--dicht', dicht);
      var regel = stap.querySelector('[data-door-stapregel]');
      if (!regel) return;
      regel.hidden = !dicht;
      /* De regel is de knop die de stap opent; een schermlezer hoort zo of
         de inhoud eronder open of dicht staat. */
      regel.setAttribute('aria-expanded', dicht ? 'false' : 'true');
      var waarde = regel.querySelector('[data-door-stapwaarde]');
      if (waarde) waarde.textContent = gekozenTekst(stap);
    }

    /* De bovenkant van het blok vasthouden over een verandering heen. */
    function metVastePlek(fn) {
      var voor = root.getBoundingClientRect().top;
      fn();
      var na = root.getBoundingClientRect().top;
      if (Math.abs(na - voor) > 1) window.scrollBy(0, na - voor);
    }

    function openAlleen(stap) {
      stappen.forEach(function (s) { zetStand(s, s !== stap); });
    }

    /* beginstand: de eerste zichtbare stap open, de rest dicht */
    var eerste = stappen.filter(zichtbaar)[0];
    openAlleen(eerste || null);

    /* Een keuze binnen de open stap laat die stap staan. Wat wél moet
       gebeuren, is de waarde op de ingeklapte regels bijwerken: een
       maatwissel kan de glaskeuze terugzetten op dicht leveren, en dan
       klopt de regel "Glas — Satijn vlak glas" niet meer. */
    root.addEventListener('change', function (e) {
      if (!e.target.closest || !e.target.closest('.solza-door-step')) return;
      setTimeout(function () {
        stappen.forEach(function (s) { if (isDicht(s)) zetStand(s, true); });
      }, 80);
    });

    root.addEventListener('click', function (e) {
      var regel = e.target.closest && e.target.closest('[data-door-stapregel]');
      if (!regel) return;
      e.preventDefault();
      var stap = regel.closest('.solza-door-step');
      metVastePlek(function () { openAlleen(stap); });
    });
  }

  /* -- maatfilter op de toebehoren-rij ------------------------------
     Server-side krijgt elke kaart data-acc-width (0 = maatloos, blijft
     altijd staan). Bij een maatwissel herfiltert dit dezelfde regel
     als de server: tonen bij breedte-match of maatloos, tot het
     maximum (data-acc-max) aan zichtbare kaarten; nul zichtbaar =
     hele blok verborgen. */
  function initAccFilter(root) {
    var block = document.querySelector('.solza-door-acc-block');
    if (!block) return;
    var max = parseInt(block.getAttribute('data-acc-max'), 10) || 6;

    function selectedSize() {
      var maatStep = root.querySelector('[data-door-step][data-option-name="Maat"]');
      var checked = maatStep && maatStep.querySelector('input[type="radio"]:checked');
      if (!checked) return { w: null, h: null };
      var parts = checked.value.split('x');
      var w = parseFloat((parts[0] || '').replace(',', '.'));
      var h = parseFloat((parts[1] || '').replace('cm', '').trim().replace(',', '.'));
      return { w: isNaN(w) ? null : w, h: isNaN(h) ? null : h };
    }

    function apply() {
      var sel = selectedSize();
      var shown = 0;
      [].slice.call(block.querySelectorAll('.solza-door-acc')).forEach(function (row) {
        var rw = parseFloat(row.getAttribute('data-acc-width') || '0') || 0;
        var widthOk = rw === 0 || sel.w === null || Math.abs(rw - sel.w) < 0.01;
        /* hoogteclaim: "201.5/211.5" past bij beide hoogtes */
        var rh = row.getAttribute('data-acc-heights') || '';
        var heightOk = rh === '' || sel.h === null || rh.split('/').some(function (v) {
          return Math.abs(parseFloat(v) - sel.h) < 0.01;
        });
        var visible = widthOk && heightOk && shown < max;
        if (visible) shown++;
        row.hidden = !visible;
      });
      block.hidden = shown === 0;
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-door-step] input[type="radio"]')) {
        /* na de stille doorschakel-kliks van refresh() opnieuw meten */
        setTimeout(apply, 60);
      }
    });
  }

  /* -- stappen 4-6 (Afwerking/Glas/Bewerkingen) --------------------
     Extra keuzes bovenop de variant. Toeslagen (uit de server-side
     gerenderde data-attributen) tellen op bij de variantprijs in de
     totaalregel en de sticky balk; gekozen opties gaan als line item
     properties mee met de winkelwagenregel. De retourmelding
     verschijnt zodra er wordt afgelakt of bewerkt. */
  function initExtras(root, variants) {
    var extraSteps = [].slice.call(root.querySelectorAll('[data-door-extra]'));
    var returnNote = root.querySelector('[data-door-return-note]');
    if (!extraSteps.length) return null;

    var productId = root.getAttribute('data-product-id');
    var mainForm = document.querySelector('.m-product-form--main form');
    var priceEl = document.querySelector('.main-product__block-price .m-price-item');
    var stickyPriceEl = document.querySelector('[data-sticky-atc-price]');
    var basePrice = null;

    /* startprijs: de nu geselecteerde variant (of de eerste) */
    var idInput = mainForm && mainForm.querySelector('[name="id"]');
    var startId = idInput && Number(idInput.value);
    var startVariant = null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id === startId) { startVariant = variants[i]; break; }
    }
    basePrice = (startVariant || variants[0] || {}).price;

    function surchargeInputs() {
      return [].slice.call(root.querySelectorAll('[data-door-extra] input[data-door-surcharge]'));
    }

    var glasSjabloon = root.getAttribute('data-door-glas-label') || '';

    function state() {
      var total = 0;
      var lakt = false, bewt = false;
      var props = [];
      var regels = [];
      surchargeInputs().forEach(function (input) {
        if (!input.checked) return;
        var cents = parseInt(input.getAttribute('data-door-surcharge'), 10) || 0;
        total += cents;
        var step = input.closest('[data-door-extra]');
        var kind = step && step.getAttribute('data-door-extra');
        var prop = input.getAttribute('data-door-prop') || '';
        if (kind === 'finish' && prop) { lakt = true; props.push(['Afwerking', prop]); }
        if (kind === 'processing' && prop) {
          bewt = true;
          props.push(['Bewerking: ' + prop, input.getAttribute('data-door-prop-value') || 'Ja']);
        }

        /* Alleen keuzes die geld kosten krijgen een regel in de
           samenvatting. "Dicht leveren" en "Gegrond" zijn de standaard
           en horen daar niet als nulregel te staan. */
        if (cents <= 0) return;
        var soort = input.getAttribute('data-door-glas-soort');
        regels.push({
          wat: soort ? glasNaam(soort, glasSjabloon) : pilLabel(input),
          centen: cents
        });
      });
      return { surcharge: total, lakt: lakt, bewt: bewt, props: props, regels: regels };
    }

    function syncProps(props) {
      if (!mainForm) return;
      [].slice.call(mainForm.querySelectorAll('[data-door-extra-prop]')).forEach(function (el) { el.remove(); });
      props.forEach(function (pair) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + pair[0] + ']';
        input.value = pair[1];
        input.setAttribute('data-door-extra-prop', '');
        mainForm.appendChild(input);
      });
    }

    /* -- samenvatting boven het totaal ------------------------------
       Deur, glas en eventuele toeslagen als losse regels met hun bedrag,
       met de totaalregel van het prijsblok er direct onder. De bedragen
       staan alleen hier; de ingeklapte stapregels tonen enkel de gekozen
       waarde. */
    var samenvatting = root.querySelector('[data-door-samenvatting]');
    var deurRegel = samenvatting && samenvatting.querySelector('[data-door-sam-deur]');

    function geld(centen) {
      if (typeof formatMoney !== 'function' || !window.MinimogSettings) return '';
      return formatMoney(centen, MinimogSettings.money_format);
    }

    /* De deurregel: titel plus de opties waar de klant werkelijk iets
       heeft gekozen. Een stap die verborgen is omdat er maar één
       mogelijkheid was, hoort er niet bij -- die zegt niets. */
    function deurOmschrijving() {
      var delen = [root.getAttribute('data-door-titel') || ''];
      [].slice.call(root.querySelectorAll('[data-door-step][data-option-name]')).forEach(function (stap) {
        if (stap.classList.contains('solza-door-step--hidden')) return;
        if (stap.classList.contains('solza-door-step--eenkeuze')) return;
        var aan = stap.querySelector('input[type="radio"]:checked');
        if (aan && aan.value) delen.push(aan.value);
      });
      return delen.filter(Boolean).join(' · ');
    }

    function zetRegel(wat, centen) {
      var regel = document.createElement('p');
      regel.className = 'solza-door-samenvatting__regel';
      var links = document.createElement('span');
      links.className = 'solza-door-samenvatting__wat';
      links.textContent = wat;
      var rechts = document.createElement('span');
      rechts.className = 'solza-door-samenvatting__bedrag';
      rechts.textContent = geld(centen);
      regel.appendChild(links);
      regel.appendChild(rechts);
      return regel;
    }

    function tekenSamenvatting(s) {
      if (!samenvatting || !deurRegel) return;

      var wat = deurRegel.querySelector('[data-door-sam-wat]');
      var bedrag = deurRegel.querySelector('[data-door-sam-bedrag]');
      if (wat) wat.textContent = deurOmschrijving();
      if (bedrag) bedrag.textContent = basePrice != null ? geld(basePrice) : '';

      [].slice.call(samenvatting.querySelectorAll('[data-door-sam-extra]')).forEach(function (el) { el.remove(); });
      s.regels.forEach(function (r) {
        var el = zetRegel(r.wat, r.centen);
        el.setAttribute('data-door-sam-extra', '');
        samenvatting.appendChild(el);
      });

      samenvatting.hidden = basePrice == null;
    }

    function render() {
      var s = state();
      if (typeof formatMoney === 'function' && window.MinimogSettings && basePrice != null) {
        var totalText = formatMoney(basePrice + s.surcharge, MinimogSettings.money_format);
        if (priceEl) priceEl.textContent = totalText;
        if (stickyPriceEl) stickyPriceEl.textContent = totalText;
      }
      if (returnNote) returnNote.hidden = !(s.lakt || s.bewt);
      syncProps(s.props);
      tekenSamenvatting(s);
    }

    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-door-extra]')) render();
    });

    /* variantwissel: nieuwe basisprijs, daarna toeslagen er weer
       bovenop (na de vendor- en sticky-updates in dezelfde tick) */
    if (window.MinimogEvents && productId) {
      window.MinimogEvents.subscribe(productId + '__VARIANT_CHANGE', function (variant) {
        if (variant && variant.price != null) basePrice = variant.price;
        setTimeout(render, 0);
      });
    }

    render();
    return render;
  }

  /* -- stap Glas ----------------------------------------------------
     Glas is geen toeslag op de deurregel maar een eigen product met een
     variant per maat. Deze functie doet drie dingen:

     1. bij elke maatwissel de bijpassende glasvariant zoeken en de
        soorten zonder variant in die maat verbergen (niet uitgrijzen --
        een soort die er in deze maat niet is, hoort niet in beeld);
     2. de prijs van die variant als toeslag doorgeven, zodat de
        totaalprijs bovenaan deur plus glas toont als één bedrag;
     3. het toevoegen onderscheppen en twee gekoppelde regels posten.

     De koppeling loopt via de property _config: dezelfde waarde op beide
     regels. Properties met een underscore zijn verborgen voor de klant,
     dus de mand toont er niets van; de winkelmand gebruikt ze wel om de
     regels bij elkaar te houden en samen te verwijderen. */
  function initGlas(root, hertekenPrijs) {
    var stap = root.querySelector('[data-door-glas]');
    if (!stap) return;

    var dataEl = stap.querySelector('[data-door-glas-data]');
    var opties;
    try { opties = JSON.parse(dataEl.textContent).opties; } catch (e) { return; }
    if (!opties || !opties.length) return;

    var pillen = [].slice.call(stap.querySelectorAll('.solza-door-glaspil'));
    var basis = stap.querySelector('input[data-door-glas-soort=""]');

    /* "83 x 211,5 cm" -> ["83", "211,5"]. Dezelfde normalisatie als
       server-side op de variantmaten is toegepast, zodat er maar op één
       plek een spatie of een "cm" hoeft te verdwijnen. */
    function maatDelen(waarde) {
      var schoon = String(waarde || '').replace(/\s|cm/g, '');
      var delen = schoon.split('x');
      return { breedte: delen[0] || '', hoogte: delen[1] || '' };
    }

    function gekozenMaat() {
      var maatStap = root.querySelector('[data-door-step][data-option-name="Maat"]');
      var aangevinkt = maatStap && maatStap.querySelector('input[type="radio"]:checked');
      return aangevinkt ? maatDelen(aangevinkt.value) : { breedte: '', hoogte: '' };
    }

    /* De variant waarvan de breedte gelijk is en de hoogtelijst de
       deurhoogte bevat. "78x201,5/211,5" dekt twee hoogtes. */
    function vindVariant(optie, maat) {
      if (!maat.breedte || !maat.hoogte) return null;
      for (var i = 0; i < optie.v.length; i++) {
        var deel = maatDelen(optie.v[i].m);
        if (deel.breedte !== maat.breedte) continue;
        if (deel.hoogte.split('/').indexOf(maat.hoogte) !== -1) return optie.v[i];
      }
      return null;
    }

    function geld(centen) {
      if (typeof formatMoney !== 'function' || !window.MinimogSettings) return '';
      return formatMoney(centen, MinimogSettings.money_format);
    }

    function verversGlas() {
      var maat = gekozenMaat();
      var verlorenKeuze = false;

      pillen.forEach(function (pil) {
        var optie = opties[parseInt(pil.getAttribute('data-door-glas-index'), 10)];
        var invoer = pil.querySelector('input[type="radio"]');
        var variant = optie ? vindVariant(optie, maat) : null;

        if (!variant) {
          if (invoer.checked) verlorenKeuze = true;
          pil.hidden = true;
          invoer.removeAttribute('data-door-glas-variant');
          invoer.setAttribute('data-door-surcharge', '0');
          return;
        }

        pil.hidden = false;
        invoer.setAttribute('data-door-glas-variant', variant.i);
        invoer.setAttribute('data-door-surcharge', variant.p);
        var prijsEl = pil.querySelector('[data-door-glas-prijs]');
        if (prijsEl) prijsEl.textContent = '+ ' + geld(variant.p);
      });

      /* Was de gekozen soort er in de vorige maat wel en in deze niet,
         dan valt de keuze terug op dicht leveren. Stil laten staan zou
         een prijs opleveren voor glas dat niet besteld kan worden. */
      if (verlorenKeuze && basis) basis.checked = true;
      if (hertekenPrijs) hertekenPrijs();
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-door-step] input[type="radio"]')) {
        /* na de stille doorschakel-kliks van refresh() opnieuw meten */
        setTimeout(verversGlas, 60);
      }
    });

    verversGlas();
    initGlasWinkelwagen(root, stap);
  }

  /* Toevoegen met glas: twee regels in plaats van één.

     Alleen onderscheppen wanneer er werkelijk glas is gekozen. Staat de
     keuze op dicht leveren, dan doet het gewone formulier zijn werk en
     raken we niets aan -- hoe minder van het theme we overnemen, hoe
     minder er bij een theme-update stukgaat.

     De route naar de winkelwagen is dezelfde die solza-vloer-pdp.js voor
     bundels gebruikt: fetchConfig van het theme, cart_add_url, en daarna
     de lade laten verversen met renderContents. Een eigen tweede pad zou
     bij de eerstvolgende vendorwijziging uit de pas lopen. */
  function initGlasWinkelwagen(root, stap) {
    function gekozenGlas() {
      var aangevinkt = stap.querySelector('input[type="radio"]:checked[data-door-glas-variant]');
      if (!aangevinkt) return null;
      var id = parseInt(aangevinkt.getAttribute('data-door-glas-variant'), 10);
      if (!id) return null;
      return { id: id, soort: aangevinkt.getAttribute('data-door-glas-soort') || '' };
    }

    document.addEventListener(
      'submit',
      function (e) {
        var formulier = e.target;
        if (!formulier || !formulier.matches || !formulier.matches('form[action*="/cart/add"]')) return;

        var deurVeld = formulier.querySelector('[name="id"]');
        if (!deurVeld || !deurVeld.value) return;

        var glas = gekozenGlas();
        if (!glas) return;

        if (typeof window.fetchConfig !== 'function' || !window.MinimogSettings) return;

        e.preventDefault();
        e.stopPropagation();

        var aantalVeld = formulier.querySelector('[name="quantity"]');
        var aantal = parseInt(aantalVeld && aantalVeld.value, 10) || 1;

        /* De keuzes uit de stappen Afwerking en Bewerkingen staan als
           verborgen velden op het hoofdformulier. Die horen op de deurregel
           te blijven staan; ze gaan hier dus mee.

           Bewust uit het hoofdformulier en niet uit het formulier dat
           submit: de sticky balk onderaan heeft een eigen formulier zonder
           die velden, en dan zou een gekozen afwerking stilletjes van de
           bestelling vallen. */
        var hoofdformulier = document.querySelector('.m-product-form--main form') || formulier;
        var eigenschappen = {};
        [].slice.call(hoofdformulier.querySelectorAll('[name^="properties["]')).forEach(function (veld) {
          if (!veld.value) return;
          var naam = veld.name.slice('properties['.length, -1);
          eigenschappen[naam] = veld.value;
        });

        var cfg = Date.now().toString(36);
        eigenschappen._config = cfg;

        /* _glas draagt de gekozen soort mee naar de winkelwagen. De
           producttitel van het toeslagproduct ("Toeslag glas Satijn vlak
           glas voor New York") is geen naam waar een klant iets aan
           heeft, en hem uitkleden met tekstbewerking breekt zodra iemand
           een van de tweeëntachtig toeslagproducten hernoemt. Een
           eigenschap met een underscore is verborgen voor de klant. */
        var glasEigenschappen = { _config: cfg, _hoort_bij: 'deur' };
        if (glas.soort) glasEigenschappen._glas = glas.soort;

        var regels = [
          { id: parseInt(deurVeld.value, 10), quantity: aantal, properties: eigenschappen },
          { id: glas.id, quantity: aantal, properties: glasEigenschappen }
        ];

        naarWinkelwagen(regels, formulier);
      },
      true /* capture: vóór de vendor-afhandeling van het formulier */
    );
  }

  function naarWinkelwagen(regels, formulier) {
    var knop = formulier.querySelector('[type="submit"]');
    var lade = document.querySelector('m-cart-drawer');
    var lichaam = { items: regels };

    if (lade && typeof lade.getSectionsToRender === 'function') {
      lichaam.sections = lade.getSectionsToRender().map(function (s) { return s.id; });
      lichaam.sections_url = window.location.pathname;
    }

    var config = window.fetchConfig('javascript');
    config.method = 'POST';
    config.body = JSON.stringify(lichaam);

    if (knop) knop.setAttribute('aria-disabled', 'true');

    fetch(window.MinimogSettings.routes.cart_add_url, config)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          /* Mislukt het toevoegen, dan blijft de klant op de pagina met
             een melding van Shopify zelf; stil falen zou de indruk wekken
             dat de deur in de mand ligt. */
          if (window.MinimogTheme && window.MinimogTheme.Notification) {
            window.MinimogTheme.Notification.show({
              target: formulier,
              type: 'warning',
              message: data.description || data.message
            });
          }
          return;
        }
        if (!window.MinimogSettings.use_ajax_atc) {
          window.location = window.MinimogSettings.routes.cart;
          return;
        }
        if (window.MinimogSettings.enable_cart_drawer && lade) lade.renderContents(data);
        if (window.MinimogEvents && window.MinimogTheme) {
          window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, data);
        }
      })
      .catch(function () {})
      .finally(function () {
        if (knop) knop.removeAttribute('aria-disabled');
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
